import { useDataChannel, useRoomContext } from "@livekit/components-react";
import { useEffect, useMemo, useRef } from "react";
import { toast } from "react-toastify";

// Use recording id from livekit room metadata, NOT our database room
export const useRecordingId = () => {
  const livekitRoom = useRoomContext();

  return useMemo<string | undefined>(() => {
    if (!livekitRoom.metadata) {
      return undefined;
    }
    try {
      const { recording_id: recordingId } = JSON.parse(livekitRoom.metadata);
      return recordingId || undefined;
    } catch (error) {
      console.error("Error parsing room metadata for recording ID:", error);
      return undefined;
    }
  }, [livekitRoom.metadata]);
};

// Show start/stop toast for recording
export const useRecordingToast = (params: {
  inProgressToast: JSX.Element;
  stopToast: JSX.Element;
}) => {
  const livekitRoom = useRoomContext();

  const lastRecordingId = useRef<string | undefined>();

  // Toast on recoding stopped
  useEffect(() => {
    let recordingId: string | undefined;
    if (livekitRoom.metadata) {
      try {
        const { recording_id: recordingIdFromMetadata } = JSON.parse(
          livekitRoom.metadata
        );
        recordingId = recordingIdFromMetadata || undefined;
      } catch (error) {
        console.error("Error parsing room metadata for recording ID:", error);
      }
    }

    // Don't do anything when recordingId did not actually change
    if (lastRecordingId.current === recordingId) {
      return;
    }
    // Don't show toast on initial load
    if (lastRecordingId.current && !recordingId) {
      toast(params.stopToast);
    }
    lastRecordingId.current = recordingId;
  }, [livekitRoom.metadata, params.inProgressToast, params.stopToast]);

  // Toast on start recording success (won't show to new participants)
  useDataChannel("start_recording_success", () => {
    toast(params.inProgressToast);
  });
};
